<template>
  <NuxtLayout>
    <!-- <NuxtLoadingIndicator color="#d62022" /> -->
    <NuxtPage />
  </NuxtLayout>
  <LazyDebugDrawer v-if="$config.public.showDebugUI" />
  <ModalDialogConnected />
  <GlobalToast />
  <Body :style="style" />
</template>
<script setup lang="ts">
const { isSideNavOpen } = useSideNav()
const style = computed(() => {
  return {
    // 下層コンポーネントで利用するため、ここで定義しておく
    '--flexible-navigation-width': isSideNavOpen.value
      ? SIDE_NAVIGATION_WIDTH + 'px'
      : SIDE_NAVIGATION_CLOSED_WIDTH + 'px',
    'overflow-wrap': 'anywhere',
    'word-break': 'normal',
    'line-break': 'strict',
  }
})

onMounted(async () => {
  const { accountInfo } = useAuth()
  watch(
    accountInfo,
    async (current) => {
      if (current) {
        useNuxtApp().$karte.identify()
      }
    },
    { immediate: true }
  )
})
</script>
